<template>
  <footer class="premium-footer">
    <v-container fluid class="pa-0">
      <v-row no-gutters align="center" class="footer-row px-6">
        <!-- Left Section: Copyright -->
        <v-col cols="12" md="4" class="footer-col left-col">
          <div class="footer-content">
            <v-icon size="16" color="#ffb400" class="mr-2"
              >mdi-copyright</v-icon
            >
            <span class="copyright-text">{{ CurrentYear }}</span>
            <a
              href="https://jciindia.in"
              target="_blank"
              class="footer-link ml-2"
              >JCI India</a
            >
          </div>
        </v-col>

        <!-- Center Section: Version Warning -->
        <v-col cols="12" md="4" class="footer-col center-col">
          <div class="version-alert" v-if="VersionInfo">
            <v-icon size="14" color="#ffb400" class="mr-2"
              >mdi-alert-circle-outline</v-icon
            >
            <span>{{ VersionInfo }}</span>
          </div>
        </v-col>

        <!-- Right Section: Powered By & Version -->
        <v-col cols="12" md="4" class="footer-col right-col">
          <div class="footer-content">
            <span class="powered-text">Powered by</span>
            <a
              href="http://vaagai.org.in"
              target="_blank"
              class="footer-link vaagai-link mx-2"
              >Vaagai Tecknowledge</a
            >
            <div class="version-badge">
              <span class="v-label">v</span>{{ AppVersion }}
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </footer>
</template>

<script>
import { version } from "/package.json";
import common from "@/Common.vue";

export default {
  mixins: [common],
  data() {
    return {
      AppVersion: version,
      VersionInfo: "",
      CurrentYear: new Date().getFullYear(),
    };
  },
  beforeMount() {
    var url2 = "api/pages/version-info";
    var condition2 = {
      UserInterface: 7,
    };
    this.getPageDetails("VersionInfo", "", url2, condition2);
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&display=swap");

.premium-footer {
  background: rgba(10, 25, 47, 0.8);
  backdrop-filter: blur(10px);
  color: rgba(255, 255, 255, 0.7);
  padding: 12px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  font-family: "Outfit", sans-serif;
  position: relative;
  z-index: 100;
}

.footer-row {
  min-height: 40px;
}

.footer-col {
  display: flex;
  align-items: center;
  padding: 4px 0;
}

.left-col {
  justify-content: flex-start;
}
.center-col {
  justify-content: center;
}
.right-col {
  justify-content: flex-end;
}

.footer-content {
  display: flex;
  align-items: center;
  font-size: 0.85rem;
  font-weight: 400;
}

.copyright-text {
  color: #ffffff;
  font-weight: 500;
}

.footer-link {
  color: #00d2ff;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    bottom: -2px;
    left: 0;
    width: 0;
    height: 1px;
    background: #ffb400;
    transition: width 0.3s ease;
  }

  &:hover {
    color: #ffb400;
    &::after {
      width: 100%;
    }
  }
}

.version-alert {
  font-size: 0.8rem;
  font-weight: 500;
  color: #ffb400;
  background: rgba(255, 180, 0, 0.1);
  padding: 4px 16px;
  border-radius: 20px;
  border: 1px solid rgba(255, 180, 0, 0.2);
  display: flex;
  align-items: center;
}

.powered-text {
  opacity: 0.6;
}

.vaagai-link {
  color: #56bda3;
  &::after {
    background: #56bda3;
  }
}

.version-badge {
  background: rgba(0, 210, 255, 0.1);
  color: #00d2ff;
  padding: 2px 10px;
  border-radius: 6px;
  border: 1px solid rgba(0, 210, 255, 0.2);
  font-family: monospace;
  font-size: 0.75rem;
  font-weight: 700;
  margin-left: 8px;

  .v-label {
    opacity: 0.5;
    margin-right: 2px;
  }
}

@media (max-width: 960px) {
  .footer-col {
    justify-content: center;
    padding: 8px 0;
  }

  .version-alert {
    margin: 4px 0;
  }
}
</style>

